var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"consumption-service-charts-mqtt"},[_c('OfflineChart',{attrs:{"chartData":_vm.mockChartData,"minValueMockData":0,"maxValueMockData":100,"showKalendarButton":false,"navigationItemsToExclude":['live','hour'],"chartHeight":700,"showNavigationButtons":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }